import {getTimeDiffMs, getTimeFromDT} from "@src/utils/formatDate.ts";
import {CheckInOutPair} from "@src/httpClient/__generated__/Api.ts";


export const calculateWorkingTime = (events: CheckInOutPair[], serverWorkingTime: number = 0) => {
    if (!events) return 0
    let milliseconds = 0
    for (const [num, group] of events.entries()) {
        if (!group?.event_in?.recorded_at) continue
        let start = getTimeFromDT(group.event_in.recorded_at, true)

        if (!group?.event_out?.recorded_at && num === (events?.length - 1)) {
            const end = getTimeFromDT(new Date().toString(), true)
            milliseconds += getTimeDiffMs(end, start)
            continue;
        }

        let finish = group?.event_out?.recorded_at ? getTimeFromDT(group?.event_out?.recorded_at, true) : getTimeFromDT((new Date()).toString())
        milliseconds += getTimeDiffMs(finish, start)
    }
    if (serverWorkingTime) {
        // backend don`t calculate total_time before checkout
        return serverWorkingTime > milliseconds ? serverWorkingTime : milliseconds
    }
    return milliseconds;
}
